import {Chip, Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useState} from "react";
import {TableHead} from "../../system/thead";


const TABLE_HEAD = ["#", "کاربر", "مباشر", "نوع سرویس", "رشته", "گرایش", "وضعیت", "مبلغ", "ایجاد", "پرداخت"];

export function WorkReportGrid({
                                 workReport,
                                 setSortBy,
                                 sortType,
                                 setSortType
                               }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "مباشر": "agent_name",
    "نوع سرویس": "type",
    "رشته": "field_title",
    "گرایش": "branch_title",
    "وضعیت": "status",
    "مبلغ": "price",
    "ایجاد": "created_at",
    "پرداخت": "paid_at",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "مباشر": true,
    "نوع سرویس": true,
    "رشته": true,
    "گرایش": true,
    "وضعیت": true,
    "مبلغ": true,
    "ایجاد": true,
    "پرداخت": true,
  }

  return (
    <div className="w-full">
      <table className="mt-4 w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="w-full textCenter">
        {workReport.map(
          ({
             id,
             person_name,
             person_phone,
             agent_name,
             agent_phone,
             type,
             field_title,
             branch_title,
             status,
             price,
             created_at,
             paid_at
           }, index) => {
            const isLast = index === workReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(person_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {agent_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(agent_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {type === 'reservation' ? "خدمات" : "مشاوره"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant="ghost"
                      value={status === 'new' ? "جدید" :
                        status === 'waiting' ? 'در انتظار پرداخت' :
                          status === 'payment' ? 'درحال انجام' :
                            status === 'finish' ? 'اتمام خدمت' :
                              status === 'enable' ? 'فعال' :
                                status === 'disable' ? 'غیر فعال' :
                                  status}
                      color={status === 'new' ? "cyan" :
                        status === 'waiting' ? 'amber' :
                          status === 'payment' ? 'indigo' :
                            status === 'finish' ? 'green' :
                              status === 'enable' ? 'green' :
                                status === 'disable' ? 'red' :
                                  status}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(price, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    {created_at?.length > 0 &&
                      <>
                        <Typography color="blue-gray">
                          {persianNumberFormat(created_at.split(" ")[0])}
                        </Typography>
                        <Typography color="blue-gray">
                          {persianNumberFormat(created_at.split(" ")[1])}
                        </Typography>
                      </>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    {paid_at?.length > 0 &&
                      <>
                        <Typography color="blue-gray">
                          {persianNumberFormat(paid_at.split(" ")[0])}
                        </Typography>
                        <Typography color="blue-gray">
                          {persianNumberFormat(paid_at.split(" ")[1])}
                        </Typography>
                      </>
                    }
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}